export class marketNewsModel {
setValue(res){
if(res){
}
}
}